import React, { useEffect, useState } from "react";
import { getPaymentTypes } from "../../utils/dataFetch";
import BarGraphHorizontal from "../svg-graphs/BarGraphHorizontal";

export default function PaymentTypes({ startDate, endDate }) {
    const [paymentTypes, setPaymentTypes] = useState({ lastMonth: [] });
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchPaymentTypes = async () => {
            try {
                const result = await getPaymentTypes(startDate, endDate);
                setPaymentTypes(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchPaymentTypes(startDate, endDate);
    }, [endDate, startDate]);

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Види оплат</h5>
                {error && (
                    <div className="alert alert-danger m-auto rounded-5">
                        {error}
                    </div>
                )}
                {!error && (
                    <BarGraphHorizontal inputData={paymentTypes.lastMonth} />
                )}
            </div>
        </div>
    );
}
